// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.waiting-room-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #0f172a;
  background-image: 
    radial-gradient(at 0% 0%, rgba(99, 102, 241, 0.15) 0px, transparent 50%),
    radial-gradient(at 50% 0%, rgba(168, 85, 247, 0.15) 0px, transparent 50%),
    radial-gradient(at 100% 100%, rgba(59, 130, 246, 0.15) 0px, transparent 50%);
  padding: 20px;
  position: relative;
  overflow: hidden;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;
}

.waiting-room-page::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background-image: 
    radial-gradient(circle at 20% 50%, rgba(99, 102, 241, 0.08) 1px, transparent 1px),
    radial-gradient(circle at 80% 20%, rgba(168, 85, 247, 0.08) 1px, transparent 1px),
    radial-gradient(circle at 40% 80%, rgba(59, 130, 246, 0.08) 1px, transparent 1px);
  background-size: 80px 80px, 120px 120px, 100px 100px;
  animation: float 20s ease-in-out infinite;
  pointer-events: none;
}

@keyframes float {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  25% { transform: translate(2%, 1%) rotate(1deg); }
  50% { transform: translate(-1%, 2%) rotate(-1deg); }
  75% { transform: translate(1%, -1%) rotate(0.5deg); }
}

.waiting-room-card {
  position: relative;
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(40px) saturate(180%);
  -webkit-backdrop-filter: blur(40px) saturate(180%);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 
    0 25px 50px -12px rgba(0, 0, 0, 0.5),
    0 0 0 1px rgba(255, 255, 255, 0.05) inset,
    0 0 80px rgba(99, 102, 241, 0.15);
  border-radius: 24px;
  padding: 48px;
  max-width: 520px;
  width: 100%;
  text-align: center;
  animation: slideUp 0.6s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.waiting-room-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  border-radius: 24px 24px 0 0;
}

.waiting-icon {
  width: 72px;
  height: 72px;
  border-radius: 20px;
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.2), rgba(168, 85, 247, 0.2));
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  animation: pulse 2s infinite;
  backdrop-filter: blur(10px);
}

.waiting-icon::after {
  content: '🕒';
  font-size: 32px;
  filter: grayscale(0.2);
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.8;
  }
}

.success-icon {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(34, 197, 94, 0.2), rgba(74, 222, 128, 0.2));
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  font-size: 36px;
}

.error-icon {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.2), rgba(248, 113, 113, 0.2));
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  color: #fca5a5;
  font-size: 36px;
  font-weight: 700;
}

.waiting-room-card h2 {
  margin: 0 0 10px 0;
  color: #f8fafc;
  font-size: 26px;
  font-weight: 700;
  letter-spacing: -0.02em;
  background: linear-gradient(135deg, #fff 0%, rgba(255, 255, 255, 0.8) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.room-preview {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 20px;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

.room-preview:hover {
  border-color: rgba(255, 255, 255, 0.15);
  background: rgba(255, 255, 255, 0.05);
}

.room-name {
  font-size: 18px;
  font-weight: 600;
  color: #f1f5f9;
  margin-bottom: 6px;
  letter-spacing: -0.01em;
}

.room-description {
  color: #94a3b8;
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
}

.user-info {
  background: rgba(99, 102, 241, 0.08);
  border: 1px solid rgba(99, 102, 241, 0.2);
  border-radius: 14px;
  padding: 16px;
  margin-bottom: 24px;
  backdrop-filter: blur(10px);
}

.user-info p {
  margin: 0 0 6px 0;
  color: #94a3b8;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 500;
}

.user-info strong {
  display: block;
  color: #f8fafc;
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 4px;
}

.user-info span {
  color: #94a3b8;
  font-size: 13px;
}

.waiting-message {
  padding: 24px;
  background: rgba(99, 102, 241, 0.06);
  border: 1px solid rgba(99, 102, 241, 0.15);
  border-radius: 16px;
  backdrop-filter: blur(10px);
}

.spinner {
  width: 48px;
  height: 48px;
  border: 4px solid rgba(99, 102, 241, 0.15);
  border-top-color: #6366f1;
  border-radius: 50%;
  margin: 0 auto 20px;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.waiting-message p {
  margin: 0 0 8px 0;
  color: #e2e8f0;
  font-size: 15px;
  font-weight: 500;
}

.waiting-hint {
  color: #94a3b8 !important;
  font-size: 13px !important;
  font-weight: 400 !important;
}

.join-actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 8px;
}

.btn-primary {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  color: white;
  border: none;
  padding: 14px 28px;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  font-family: inherit;
  letter-spacing: 0.02em;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(99, 102, 241, 0.4);
}

.btn-primary::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255,255,255,0.15) 0%, transparent 50%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.btn-primary:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(99, 102, 241, 0.5);
}

.btn-primary:hover:not(:disabled)::before {
  opacity: 1;
}

.btn-primary:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 2px 10px rgba(99, 102, 241, 0.4);
}

.btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

.btn-large {
  padding: 16px 32px;
  font-size: 16px;
  border-radius: 14px;
}

.btn-secondary {
  background: rgba(255, 255, 255, 0.05);
  color: #e2e8f0;
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 14px 28px;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
  backdrop-filter: blur(10px);
}

.btn-secondary:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-1px);
}

.loading {
  font-size: 16px;
  color: #94a3b8;
  padding: 60px 20px;
  text-align: center;
  font-weight: 500;
}

.error-message {
  background: rgba(239, 68, 68, 0.08);
  border: 1px solid rgba(239, 68, 68, 0.2);
  color: #fca5a5;
  padding: 14px 16px;
  border-radius: 12px;
  margin-top: 20px;
  font-size: 14px;
  backdrop-filter: blur(10px);
  animation: shake 0.4s ease;
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-6px); }
  75% { transform: translateX(6px); }
}

/* Responsive */
@media (max-width: 480px) {
  .waiting-room-card {
    padding: 32px 20px;
    margin: 16px;
    border-radius: 20px;
    max-width: 100%;
  }

  .waiting-room-card h2 {
    font-size: 22px;
  }

  .room-name {
    font-size: 16px;
  }

  .btn-primary,
  .btn-secondary {
    padding: 12px 20px;
    font-size: 14px;
  }

  .btn-large {
    padding: 14px 24px;
    font-size: 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/WaitingRoom.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB;;;gFAG8E;EAC9E,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,uGAAuG;AACzG;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ;;;qFAGmF;EACnF,oDAAoD;EACpD,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,WAAW,uCAAuC,EAAE;EACpD,MAAM,yCAAyC,EAAE;EACjD,MAAM,2CAA2C,EAAE;EACnD,MAAM,4CAA4C,EAAE;AACtD;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;EAC1C,kDAAkD;EAClD,0CAA0C;EAC1C;;;qCAGmC;EACnC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,sFAAsF;EACtF,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qFAAqF;EACrF,0CAA0C;EAC1C,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,YAAY;EACd;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oFAAoF;EACpF,0CAA0C;EAC1C,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qFAAqF;EACrF,0CAA0C;EAC1C,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,2EAA2E;EAC3E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kDAAkD;EAClD,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+EAA+E;EAC/E,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,0CAA0C;EAC1C,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;EACxC,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;EACnC,MAAM,0BAA0B,EAAE;AACpC;;AAEA,eAAe;AACf;EACE;IACE,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');\n\n.waiting-room-page {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background: #0f172a;\n  background-image: \n    radial-gradient(at 0% 0%, rgba(99, 102, 241, 0.15) 0px, transparent 50%),\n    radial-gradient(at 50% 0%, rgba(168, 85, 247, 0.15) 0px, transparent 50%),\n    radial-gradient(at 100% 100%, rgba(59, 130, 246, 0.15) 0px, transparent 50%);\n  padding: 20px;\n  position: relative;\n  overflow: hidden;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;\n}\n\n.waiting-room-page::before {\n  content: '';\n  position: absolute;\n  top: -50%;\n  left: -50%;\n  width: 200%;\n  height: 200%;\n  background-image: \n    radial-gradient(circle at 20% 50%, rgba(99, 102, 241, 0.08) 1px, transparent 1px),\n    radial-gradient(circle at 80% 20%, rgba(168, 85, 247, 0.08) 1px, transparent 1px),\n    radial-gradient(circle at 40% 80%, rgba(59, 130, 246, 0.08) 1px, transparent 1px);\n  background-size: 80px 80px, 120px 120px, 100px 100px;\n  animation: float 20s ease-in-out infinite;\n  pointer-events: none;\n}\n\n@keyframes float {\n  0%, 100% { transform: translate(0, 0) rotate(0deg); }\n  25% { transform: translate(2%, 1%) rotate(1deg); }\n  50% { transform: translate(-1%, 2%) rotate(-1deg); }\n  75% { transform: translate(1%, -1%) rotate(0.5deg); }\n}\n\n.waiting-room-card {\n  position: relative;\n  background: rgba(255, 255, 255, 0.03);\n  backdrop-filter: blur(40px) saturate(180%);\n  -webkit-backdrop-filter: blur(40px) saturate(180%);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: \n    0 25px 50px -12px rgba(0, 0, 0, 0.5),\n    0 0 0 1px rgba(255, 255, 255, 0.05) inset,\n    0 0 80px rgba(99, 102, 241, 0.15);\n  border-radius: 24px;\n  padding: 48px;\n  max-width: 520px;\n  width: 100%;\n  text-align: center;\n  animation: slideUp 0.6s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px) scale(0.96);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.waiting-room-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n  border-radius: 24px 24px 0 0;\n}\n\n.waiting-icon {\n  width: 72px;\n  height: 72px;\n  border-radius: 20px;\n  background: linear-gradient(135deg, rgba(99, 102, 241, 0.2), rgba(168, 85, 247, 0.2));\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 24px;\n  animation: pulse 2s infinite;\n  backdrop-filter: blur(10px);\n}\n\n.waiting-icon::after {\n  content: '🕒';\n  font-size: 32px;\n  filter: grayscale(0.2);\n}\n\n@keyframes pulse {\n  0%, 100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(1.05);\n    opacity: 0.8;\n  }\n}\n\n.success-icon {\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, rgba(34, 197, 94, 0.2), rgba(74, 222, 128, 0.2));\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 24px;\n  font-size: 36px;\n}\n\n.error-icon {\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, rgba(239, 68, 68, 0.2), rgba(248, 113, 113, 0.2));\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 24px;\n  color: #fca5a5;\n  font-size: 36px;\n  font-weight: 700;\n}\n\n.waiting-room-card h2 {\n  margin: 0 0 10px 0;\n  color: #f8fafc;\n  font-size: 26px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  background: linear-gradient(135deg, #fff 0%, rgba(255, 255, 255, 0.8) 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.room-preview {\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 16px;\n  padding: 20px;\n  margin-bottom: 20px;\n  backdrop-filter: blur(10px);\n  transition: all 0.3s ease;\n}\n\n.room-preview:hover {\n  border-color: rgba(255, 255, 255, 0.15);\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.room-name {\n  font-size: 18px;\n  font-weight: 600;\n  color: #f1f5f9;\n  margin-bottom: 6px;\n  letter-spacing: -0.01em;\n}\n\n.room-description {\n  color: #94a3b8;\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.user-info {\n  background: rgba(99, 102, 241, 0.08);\n  border: 1px solid rgba(99, 102, 241, 0.2);\n  border-radius: 14px;\n  padding: 16px;\n  margin-bottom: 24px;\n  backdrop-filter: blur(10px);\n}\n\n.user-info p {\n  margin: 0 0 6px 0;\n  color: #94a3b8;\n  font-size: 13px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  font-weight: 500;\n}\n\n.user-info strong {\n  display: block;\n  color: #f8fafc;\n  font-size: 15px;\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.user-info span {\n  color: #94a3b8;\n  font-size: 13px;\n}\n\n.waiting-message {\n  padding: 24px;\n  background: rgba(99, 102, 241, 0.06);\n  border: 1px solid rgba(99, 102, 241, 0.15);\n  border-radius: 16px;\n  backdrop-filter: blur(10px);\n}\n\n.spinner {\n  width: 48px;\n  height: 48px;\n  border: 4px solid rgba(99, 102, 241, 0.15);\n  border-top-color: #6366f1;\n  border-radius: 50%;\n  margin: 0 auto 20px;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.waiting-message p {\n  margin: 0 0 8px 0;\n  color: #e2e8f0;\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.waiting-hint {\n  color: #94a3b8 !important;\n  font-size: 13px !important;\n  font-weight: 400 !important;\n}\n\n.join-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 8px;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);\n  color: white;\n  border: none;\n  padding: 14px 28px;\n  border-radius: 12px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n  font-family: inherit;\n  letter-spacing: 0.02em;\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0 4px 15px rgba(99, 102, 241, 0.4);\n}\n\n.btn-primary::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(135deg, rgba(255,255,255,0.15) 0%, transparent 50%);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.btn-primary:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(99, 102, 241, 0.5);\n}\n\n.btn-primary:hover:not(:disabled)::before {\n  opacity: 1;\n}\n\n.btn-primary:active:not(:disabled) {\n  transform: translateY(0);\n  box-shadow: 0 2px 10px rgba(99, 102, 241, 0.4);\n}\n\n.btn-primary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.btn-large {\n  padding: 16px 32px;\n  font-size: 16px;\n  border-radius: 14px;\n}\n\n.btn-secondary {\n  background: rgba(255, 255, 255, 0.05);\n  color: #e2e8f0;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  padding: 14px 28px;\n  border-radius: 12px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: inherit;\n  backdrop-filter: blur(10px);\n}\n\n.btn-secondary:hover {\n  background: rgba(255, 255, 255, 0.1);\n  border-color: rgba(255, 255, 255, 0.2);\n  transform: translateY(-1px);\n}\n\n.loading {\n  font-size: 16px;\n  color: #94a3b8;\n  padding: 60px 20px;\n  text-align: center;\n  font-weight: 500;\n}\n\n.error-message {\n  background: rgba(239, 68, 68, 0.08);\n  border: 1px solid rgba(239, 68, 68, 0.2);\n  color: #fca5a5;\n  padding: 14px 16px;\n  border-radius: 12px;\n  margin-top: 20px;\n  font-size: 14px;\n  backdrop-filter: blur(10px);\n  animation: shake 0.4s ease;\n}\n\n@keyframes shake {\n  0%, 100% { transform: translateX(0); }\n  25% { transform: translateX(-6px); }\n  75% { transform: translateX(6px); }\n}\n\n/* Responsive */\n@media (max-width: 480px) {\n  .waiting-room-card {\n    padding: 32px 20px;\n    margin: 16px;\n    border-radius: 20px;\n    max-width: 100%;\n  }\n\n  .waiting-room-card h2 {\n    font-size: 22px;\n  }\n\n  .room-name {\n    font-size: 16px;\n  }\n\n  .btn-primary,\n  .btn-secondary {\n    padding: 12px 20px;\n    font-size: 14px;\n  }\n\n  .btn-large {\n    padding: 14px 24px;\n    font-size: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
